import { useNavigate } from "@tanstack/react-router"
import { CustomerListSearchSchema } from "routes/_base/_auth/customers/list/route"
import { ImportCompleteStep } from "./ImportCompleteStep"
import { ImportFlow } from "./ImportFlow"

type Props = {
  onClose: () => void
  importId?: string
}

export function CustomersImport({ onClose, importId }: Props) {
  const navigate = useNavigate()

  return (
    <ImportFlow
      importId={importId}
      onClose={onClose}
      onImportIdChange={(next) =>
        navigate({
          to: "/customers/list/import",
          search: { ...CustomerListSearchSchema.parse({}), importId: next },
          replace: true,
        })
      }
      renderComplete={(state) => <ImportCompleteStep state={state} onClose={onClose} />}
    />
  )
}
